import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-fade-in">
      <Link
        to="/create"
        className="inline-flex items-center gap-2 h-12 px-6 rounded-full text-base font-bold text-primary-foreground bg-primary hover:bg-primary/90 transition-all shadow-lg shadow-primary/30"
      >
        🔥 Создать песню
      </Link>
    </div>
  );
};

export default FloatingCTA;
